/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface CustomSampleMetaData
 *
 */
// create custom validators for the regexes
export interface CustomSampleMetaData {
    [key: string]: any;
}
/**
 * Check if a given object implements the CustomSampleMetaData interface.
 */
export function instanceOfCustomSampleMetaData(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const CustomSampleMetaDataTypiaAssertEquals = (input: any) => {
    return ((input: any): CustomSampleMetaData => {
        const __is = (input: any, _exceptionable: boolean = true): input is CustomSampleMetaData => {
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return false;
            });
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CustomSampleMetaData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                });
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "CustomSampleMetaData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "CustomSampleMetaData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CustomSampleMetaDataTypiaAssertStringify = (input: CustomSampleMetaData): string => {
    return ((input: any): string => { const assert = (input: any): CustomSampleMetaData => {
        const __is = (input: any): input is CustomSampleMetaData => {
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return true;
            });
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CustomSampleMetaData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return true;
                });
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "CustomSampleMetaData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "CustomSampleMetaData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CustomSampleMetaData): string => {
        const $join = (typia.createAssertStringify as any).join;
        const $so0 = (input: any): any => `{${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; return `${JSON.stringify(key)}:${undefined !== value ? JSON.stringify(value) : undefined}`; }).filter((str: any) => "" !== str).join(",")}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const CustomSampleMetaDataValidatorShape = {};
export const CustomSampleMetaDataValidator = yup.mixed().transform((val: any) => { return val instanceof Object && !Array.isArray(val) ? val : {}; });
export const CustomSampleMetaDataStringifyShapeProperties: ObjectSchema['properties'] = {};
export const CustomSampleMetaDataStringifyShape: ObjectSchema = {
    title: 'CustomSampleMetaData Stringifier',
    type: 'object',
    properties: {
        ...CustomSampleMetaDataStringifyShapeProperties
    },
    additionalProperties: true
};
export const CustomSampleMetaDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(CustomSampleMetaDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const CustomSampleMetaDataStringify: (data: CustomSampleMetaData) => string = CustomSampleMetaDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function CustomSampleMetaDataFromJSON(json: any): CustomSampleMetaData {
    return CustomSampleMetaDataFromJSONTyped(json, false);
}
export function CustomSampleMetaDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomSampleMetaData {
    return json;
}
export function CustomSampleMetaDataToJSON(value?: CustomSampleMetaData | null): any {
    return value;
}
